import { Component, useEffect, useState, useContext } from "react";
import { Button } from "react-bootstrap";
import KeyboardIcon from "@mui/icons-material/Keyboard";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";
import DisplaySettingsIcon from "@mui/icons-material/DisplaySettings";
import T from "../../../common/traducao";
import { Atalhos } from "../../../constants/mocks/Atalhos";

const ModalAtalhos = ({children, ...props}) => {

  const constantes = T()

  const [modal, setModdal] = useState(false);
  const { closeModal,titleModal,apenasVisualizar, className, maxWidthModal} = props;

  const atalhosOptions = Atalhos();

  useEffect(() => {
    setModdal(props.modal);
  }, [props.modal]);
 
  return (
    <Dialog
      maxWidth={maxWidthModal ?? "lg"}
      fullWidth
      open={modal}
      onClose={closeModal}
      className={className}
    >
      <DialogTitle>
        <Box display={"flex"} alignItems={"center"} gap={1}>
          <DisplaySettingsIcon sx={{ display: "flex" }} />{" "}
          <Typography
            sx={{ color: "#404044", fontSize: "18px", fontWeight: "bold" }}
          >
            {titleModal}{" "}
          </Typography>
        </Box>
      </DialogTitle>
      <Divider sx={{background:"#000"}}/>
      <DialogContent>
         {atalhosOptions.map((item) => (
            <Box key={item.id} sx={{ display: "flex", gap: 1 }}>
              <KeyboardIcon sx={{ fontSize: 22 }} />
              <Typography>{item.label}</Typography>
            </Box>
          ))}
   
      </DialogContent>
      <Divider sx={{background:"#000"}}/>
      <DialogActions sx={{ gap: 1 }}>
        {/*
        !apenasVisualizar && (
            <Button
                onClick={() => handleConfirmItemSelected()}
                style={{ background: "#009984", width: "95px", border: "none" }}
            >
             {constantes.Confirmar}
           </Button>
        ) 
        
        */}
       
        <Button
          onClick={closeModal}
          style={{ background: "crimson", width: "95px", border: "none" }}
        >
          {constantes.Sair}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalAtalhos;
